/** Reads one cookie off document.cookie. Undefined when it is not set. */
export const readCookie = (name: string): string | undefined => {
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  const value = match?.[1];
  if (value === undefined) return undefined;
  // Attribution must never block a signup: a malformed escape returns raw.
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};
